import {
    aisleThumbnail,
    getCategoriesList,
    getClientFormats,
    getConnectionTimeState,
    getLinkState,
    getObstacleThumbnailsState,
    getResumeDStoreData,
    getSelectedClient,
    getStoreAvailableSessionsState,
    getStoreMapInfo,
    getStoreMapsObject,
    getUserStoresAllList,
    isExcelLoading,
    isInvLoading,
    isLoadingAisleThumbnail,
    isLoadingCategories,
    isLoadingClientFormats,
    isLoadingConnectionTime,
    isLoadingExcelByDate,
    isLoadingMapInfo,
    isLoadingMaps,
    isLoadingNavigationReportSummary,
    isLoadingObstacleThumbnails,
    isLoadingResumeDStore,
    isLoadingTaskTypes,
    isLoadingUserStores,
    isLoadingUserSuppliers,
    isPdfLoading,
    isStoreAvailableSessionsLoading,
    navigationReportSummary,
    taskTypes,
    userSuppliers,
    aislesInfo,
    isLoadingAislesInfo
} from 'core/selectors';
import { getAisleThumbnail, getDSConnectionTime, getDSInfo, getDigitalStoreExcel, getDigitalStoreInv, getDigitalStorePdf, getExcelByDate, getNavigationReportSummary, getObstacleThumbnails, getResumeDStore, getStoreMaps, getAislesInfo } from 'core/slices/digitalStore';
import { setSnackAlert } from 'core/slices/snackAlert';
import {
    getStoreAvailableSessions,
    getStoreCategories,
} from 'core/slices/store';
import { getTaskTypes } from 'core/slices/tasks';
import { getUserStores, getUserSuppliers } from 'core/slices/users';
import { connect } from 'react-redux';

import DigitalStore from '../../../../components/features/digitalStore/DigitalStore';

export default connect(state => ({
    isExcelLoading: isExcelLoading(state),
    isInvLoading: isInvLoading(state),
    isPdfLoading: isPdfLoading(state),
    selectedClient: getSelectedClient(state),
    isLoadingMapInfo: isLoadingMapInfo(state),
    storeMap: getStoreMapInfo(state),
    isLoadingUserStores: isLoadingUserStores(state),
    userStores: getUserStoresAllList(state),
    isLoadingTaskTypes: isLoadingTaskTypes(state),
    taskTypes: taskTypes(state),
    isLoadingCategories: isLoadingCategories(state),
    storeCategories: getCategoriesList(state),
    linkReceived: getLinkState(state),
    isLoadingAisleThumbnail: isLoadingAisleThumbnail(state),
    aisleThumbnail: aisleThumbnail(state),
    isLoadingExcelByDate: isLoadingExcelByDate(state),
    suppliers: userSuppliers(state),
    isLoadingSuppliers: isLoadingUserSuppliers(state),
    isLoadingResumeDStore: isLoadingResumeDStore(state),
    resumeDStore: getResumeDStoreData(state),
    clientFormats: getClientFormats(state),
    isLoadingClientFormats: isLoadingClientFormats(state),
    storeAvailableSessions: getStoreAvailableSessionsState(state),
    isStoreAvailableSessionsLoading: isStoreAvailableSessionsLoading(state),
    connectionTime: getConnectionTimeState(state),
    isLoadingConnectionTime: isLoadingConnectionTime(state),
    storeMaps: getStoreMapsObject(state),
    isLoadingMaps: isLoadingMaps(state),
    obstacleThumbnails: getObstacleThumbnailsState(state),
    isLoadingObstacleThumbnails: isLoadingObstacleThumbnails(state),
    navigationReportSummary: navigationReportSummary(state),
    isLoadingNavigationReportSummary: isLoadingNavigationReportSummary(state),
    aislesInfo: aislesInfo(state),
    isLoadingAislesInfo: isLoadingAislesInfo(state)
}), {
    setSnackAlert,
    getDigitalStoreExcel,
    getDigitalStoreInv,
    getDigitalStorePdf,
    getDSInfo,
    getUserStores,
    getTaskTypes,
    getStoreCategories,
    getAisleThumbnail,
    getExcelByDate,
    getUserSuppliers,
    getResumeDStore,
    getStoreAvailableSessions,
    getDSConnectionTime,
    getStoreMaps,
    getObstacleThumbnails,
    getNavigationReportSummary,
    getAislesInfo
})(DigitalStore);
